import { Badge } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"

import type { ListStatus } from "../../helpers/automation-list"

const BADGE_STATUS: Record<ListStatus, "success" | "warning" | "default"> = {
  active: "success",
  paused: "warning",
  draft: "default"
}

// A dot plus text, so the status never rests on colour alone.
export function StatusBadge({ status }: { status: ListStatus }) {
  const { t } = useTranslation()
  return <Badge status={BADGE_STATUS[status]} text={t(`settingsAutomation.status.${status}`)} />
}
